export const getLargeAdChoiceIconStyles = (/* theme */) => ({
  largeIconRoot: {
    width: 36,
    height: 36,
    backgroundColor: 'rgba(33, 105, 235, 1)',
    boxShadow: '0px 3px 6px 0px rgba(0, 0, 0, 0.25)',
    borderRadius: '50px',
  },
  arrowIcon: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: 'auto',
  },
});
